import common from '../contexts/en/common.json';
import language from '../contexts/en/language.json';
import loginScreen from '../contexts/en/loginScreen.json';
import offlineScreen from '../contexts/en/offlineScreen.json';
import signatureScreen from '../contexts/en/signatureScreen.json';
import mainLayout from '../contexts/en/mainLayout.json';
import dashboard from '../contexts/en/dashboard.json';
import novaAI from '../contexts/en/novaAI.json';
import shopHomePage from '../contexts/en/shopHomePage.json';
import pinAuthentication from '../contexts/en/pinAuthentication.json';
import header from '../contexts/en/header.json';
import repairDetails from '../contexts/en/repairDetails.json';
import vinScanner from '../contexts/en/vinScanner.json';
import appVersion from '../contexts/en/appVersion.json';
import createFlow from '../contexts/en/createFlow.json';

export default {
  common,
  language,
  loginScreen,
  offlineScreen,
  signatureScreen,
  mainLayout,
  dashboard,
  novaAI,
  shopHomePage,
  pinAuthentication,
  header,
  repairDetails,
  vinScanner,
  appVersion,
  createFlow,
};
